
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as _91_46_46_46slug_93CSpA_cBkW7pEP47vSOpN_U4Kc15hB3KyKwN33QELlYsMeta } from "/home/runner/work/psj-nuxt/psj-nuxt/app/pages/[...slug].vue?macro=true";
import { default as indexRNN3xxyYObDe2YwXco1db4Eq5P_5_tVYsmqw5T5ribYMeta } from "/home/runner/work/psj-nuxt/psj-nuxt/app/pages/index.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93CSpA_cBkW7pEP47vSOpN_U4Kc15hB3KyKwN33QELlYsMeta || {},
    component: () => import("/home/runner/work/psj-nuxt/psj-nuxt/app/pages/[...slug].vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexRNN3xxyYObDe2YwXco1db4Eq5P_5_tVYsmqw5T5ribYMeta || {},
    component: () => import("/home/runner/work/psj-nuxt/psj-nuxt/app/pages/index.vue")
  }
]